import React from 'react';
import styles from './style.module.css';
import clsx from 'clsx';

interface SubHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string;
  children: React.ReactNode;
  className?: string;
  topBottomMargin?: boolean | string | number; // true = use default class, else use custom value
  topMargin?: string | number;
  bottomMargin?: string | number;
}

const SubHeading: React.FC<SubHeadingProps> = ({
  children,
  width,
  style,
  className,
  topBottomMargin,
  topMargin,
  bottomMargin,
  ...rest
}) => {
  const convertMargin = (value: string | number | undefined) => {
    if (typeof value === 'number') return `${value}px`;
    if (typeof value === 'string') return value;
    return undefined;
  };

  const marginStyle = {
    ...(topBottomMargin !== undefined && typeof topBottomMargin !== 'boolean'
      ? {
          marginTop: convertMargin(topBottomMargin),
          marginBottom: convertMargin(topBottomMargin),
        }
      : {}),
    ...(topMargin !== undefined ? { marginTop: convertMargin(topMargin) } : {}),
    ...(bottomMargin !== undefined ? { marginBottom: convertMargin(bottomMargin) } : {}),
  };

  const combinedStyle = {
    ...(width ? { width } : {}),
    ...marginStyle,
    ...style,
  };

  return (
    <div
      style={combinedStyle}
      className={clsx(
        styles.subheading,
        topBottomMargin === true && styles.margin,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default SubHeading;
